import { Divider, Grid, Tooltip } from '@material-ui/core';
import DescriptionRoundedIcon from '@material-ui/icons/DescriptionRounded';
import * as userService from 'services/user';
import { SectionTitle, useCompanyFormState } from '../common';
import { amber } from '@material-ui/core/colors';
import {
  CompanyBasicFormField,
  createDropDownAttr,
  createTextAttr,
  GroupCompaniesField,
} from '../fields';
import { range } from 'lodash';
import { useState } from 'react';
import { GroupCompanyMaster } from '@lib/company';
import { HelperTextTip } from '@components/hepler-text-tip';
import { useFormContext } from 'react-hook-form';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import { VerifiedDetails } from './section-utils';
import { isDisabled } from '@testing-library/user-event/dist/utils';

export const SectionAdditionalDetails = () => {
  const { control } = useFormContext();
  const form = useFormContext();
  const { edit, company } = useCompanyFormState();

  const { user } = userService.useUser();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.attribute_section &&
      company.verified_sections.attribute_section.verified) && !edit ||
      edit
  );
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.attribute_section &&
    watchOnVerifiedSections.attribute_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.attribute_section &&
    watchOnVerifiedSections.attribute_section.verified_at + ' IST';
  return (
    <>
      <Grid container spacing={2} justify="space-between">
        <Grid item>
          <SectionTitle
            id="additional-info"
            icon={<DescriptionRoundedIcon fontSize="large" style={{ color: amber[700] }} />}
            title="Enhanced Attributes"
            subTitle="Additional details about the Company"
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px' }}>
          <Tooltip
            title={
              isLock ? (
                <>
                  {`Verified by ${verifiedBy}`}
                  <br />
                  {`Verified at ${verifiedAt}`}
                </>
              ) : (
                'Click to Lock the Section'
              )
            }>
            {isLock ? (
              <StyledFab
                color="primary"
                aria-label="add"
                style={{ backgroundColor: 'green' }}
                size="small"
                onClick={() => {
                  setLock(false);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    attribute_section: { verified: false, verified_by: null, verified_at: null, isLockApplied: false },
                  });
                }}>
                <LockClosedIcon />
              </StyledFab>
            ) : (
              <StyledFab
                color="primary"
                style={{ backgroundColor: 'red' }}
                aria-label="add"
                size="small"
                onClick={() => {
                  setLock(true);
                  form.setValue('verified_sections', {
                    ...form.watch('verified_sections'),
                    attribute_section: {
                      verified: true,
                      verified_by: user.vtr_id,
                      verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                      isLockApplied: true,
                    },
                  });
                  // company.verified_sections.attribute_section.verified_by = user.vtr_id;
                  // company.verified_sections.attribute_section.verified = true;
                }}>
                <LockOpenIcon />
              </StyledFab>
            )}
          </Tooltip>
          {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
        </Grid>
      </Grid>

      <Divider />
      <br />
      <div>
        <fieldset disabled={isLock && edit} style={{"border":"none"}}>

        
        <Grid container spacing={3}>
          {attrs.map((Attr, i) => (
            <Grid item key={i} xs={4}>
              {<CompanyBasicFormField {...Attr} />}
            </Grid>
          ))}
          <Grid item xs={4}>
            <CompanyBasicFormField
              name="data_owner"
              label="Ingestion Method"
              helperText="Ingestion method will be 'SelfService' if this company page edited via SelfService"
              // disabled={true}
              aria-readonly={true}
              value={(company?.ingestion_method == 'SelfService' || company?.data_owner == 'SelfService') ? 'SelfService' : 'DELI'}
            />
          </Grid>
          <Grid item xs={4}>
            <CompanyBasicFormField
              name="comments"
              label="Additional comments"
              rows="2"
              multiline
              helperText="Additional comments about this company, if any."
            />
          </Grid>
        </Grid>
        
        </fieldset>
      </div>
    </>
  );
};

const list = (ip: string[]) => ip.map(i => ({ label: i, value: i }));

const CategoryType = [
  'Nonprofit',
  'Partnership',
  'Self-Employed',
  'Privately Held',
  'Government Agency',
  'Sole Proprietorship',
  'Educational Institution',
  'Public Company',
  // 'Media Production'
];
const SourcesList = [
  // 'TMDB',
  'OMDB',
  'KFTV',
  'Vitrina',
  'Wikidata',
  'Cineuropa',
  'MIPTV 2021',
  'Gala Global',
  'Production Hub',
  'Unifrance',
  'Location Guide',
  'FilmItalia',
  'FilmArt 2020',
  'NATPE 2020',
  'BBC Supplier',
  'GVD',
];
const CompanySizeList = [
  '0-1',
  '2-10',
  '11-50',
  '51-200',
  '201-500',
  '501-1,000',
  '1,001-5,000',
  '5,001-10,000',
  '10,001+',
];
const CompanyAnnualrevenue = [
  'Less than $1M',
  '$1M - $5M',
  '$5M - $10M',
  '$10M - $50M',
  '$50M - $100M',
  '$100M - $500M',
  '$500M - $1B',
  'More than $1B'
];

const CompanyActiveInactive = ['Active', 'Inactive'];

const StandaloneCompany = ['Yes', 'No'];

const CompanyFundingStatus = ['Open for Funding', 'Open for Co-Production'];

const CompanyYearOptions = range(new Date().getFullYear(), 1849, -1).map(s => s.toString());

const GroupCompaniesList = Object.values(GroupCompanyMaster);
const attrs = [createDropDownAttr(
  'company_size',
  'Size (No.# of Employees)',
  'Company Team Strength',
  CompanySizeList.map(label => ({ label, value: `${label} employees` }))
),
createDropDownAttr(
  'company_founding_year',
  'Founding Year',
  'Year the Company was set up',
  list(CompanyYearOptions)
),

createDropDownAttr(
  'company_annual_revenue',
  'Annual Revenue (in US Dollar)',
  'Annual Revenue Range',
  CompanyAnnualrevenue.map(label => ({ label, value: `${label}` }))
),
  createDropDownAttr('company_status', 'Category', 'Company Status', list(CategoryType)),
  // createTextAttr(
  //   'brand',
  //   'Brand',
  //   <HelperTextTip text="Name of the Brand" tip="[Tip: Check spelling, cases, spaces]" />
  // ),
  // createTextAttr(
  //   'owner',
  //   'Owner',
  //   <HelperTextTip text="Name of the Owner" tip=" [Tip: Check spelling, cases, spaces]" />
  // ),
  // createTextAttr(
  //   'corporation',
  //   'Corporation',
  //   <HelperTextTip text="Name of the Corporation" tip="[Tip: Check spelling, cases, spaces]" />
  // ),

  // ({ control }) => <GroupCompaniesField control={control} name="group_company_name" />,

  createTextAttr(
    'company_former_name',
    'Former Name',
    <HelperTextTip
      text="Previous Name of the Company"
      tip="[Tip: Cannot be same as current company name!]"
    />
  ),
  createTextAttr(
    'vtr_company_legal_name',
    'Legal Name',
    'Legal Name or Registered Name of the Company'
  ),
  createDropDownAttr(
    'company_acquired_year',
    'Acquired Year',
    'Year in which the Company was Merged or Acquired',
    list(CompanyYearOptions)
  ),
  createDropDownAttr(
    'company_active',
    'Active/Inactive',
    'Company Active/Inactive',
    CompanyActiveInactive.map(label => ({ label, value: `${label}` }))
  ),
  createDropDownAttr(
    'standalone_company',
    'Standalone Company',
    'Standalone Company',
    StandaloneCompany.map(label => ({ label, value: `${label}` }))
  ),
  createDropDownAttr('source_data_name', 'Source', 'Data Source', list(SourcesList)),
  // createDropDownAttr(
  //   'Ingestion',
  //   'Ingestion Method',
  //   'Ingestion method will be "SelfService" if this company page edited via SelfService',
  //   Ingestion.map(label => ({ label, value: `${label}` }))
  // ),
];

const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
